import { ApiError } from 'src/error/customError/ApiError';
export class PermissionError extends ApiError {}
